import request from "./request.js";

export default {
  getList: (data) =>
    request({
      url: "api/admin/reviewReward/list",
      data,
      method: "post",
    }).then((res) => res.data),

  audit: (data) =>
    request({
      url: "api/admin/reviewReward/audit",
      data,
      method: "post",
    }).then((res) => res.data),
};
